import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  projects: null,
  error: null,
  loader: false,

  projectDetails: null,

  registerProjectErrors: null,
  registerProjectLoader: false,
  registerProjectSuccess: false,

  suspendProjectDetails: {},
  suspendProjectErrors: null,
  suspendProjectSuccess: false,
  suspendProjectLoader: false,
};

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_TYPES.FETCH_PROJECTS_REQUEST:
      return { ...state, loader: true, errors: null };

    case ACTIONS_TYPES.FETCH_PROJECTS_SUCCESS:
      return { ...state, projects: action.payload, loader: false };

    case ACTIONS_TYPES.FETCH_PROJECTS_FAILED:
      return { ...state, loader: false, errors: action.payload };

    case ACTIONS_TYPES.REGISTER_PROJECT_REQUEST:
      return { ...state, registerProjectLoader: true, registerProjectErrors: null, registerProjectSuccess: false };

    case ACTIONS_TYPES.REGISTER_PROJECT_SUCCESS:
      return { ...state, projectDetails: action.payload, registerProjectLoader: false, registerProjectSuccess: true };

    case ACTIONS_TYPES.REGISTER_PROJECT_FAILED:
      return { ...state, registerProjectLoader: false, registerProjectErrors: action.payload };

    case ACTIONS_TYPES.SUSPEND_PROJECT_REQUEST:
      return { ...state, suspendProjectLoader: true, suspendProjectErrors: null, suspendProjectSuccess: false };

    case ACTIONS_TYPES.SUSPEND_PROJECT_SUCCESS:
      return { ...state, suspendProjectDetails: action.payload, suspendProjectLoader: false, suspendProjectSuccess: true };

    case ACTIONS_TYPES.SUSPEND_PROJECT_FAILED:
      return { ...state, suspendProjectLoader: false, suspendProjectErrors: action.payload };

    case ACTIONS_TYPES.SUSPEND_PROJECT_RESET:
      return { ...state,  suspendProjectErrors: null, suspendProjectSuccess: false };

    case ACTIONS_TYPES.REGISTER_PROJECT_RESET:
      return { initialState }

    default:
      return state;
  }
}